<template>
  <header
    ref="header"
    class="sticky top-0 z-40 transition-all duration-300"
    :class="
      scrolled
        ? 'bg-darkGunmetal/80 backdrop-blur border-b border-gunMetal shadow-lg'
        : 'bg-transparent border-b border-transparent'
    "
  >
    <nav class="mx-auto max-w-6xl px-6 md:px-12" aria-label="Top">
      <div class="w-full py-5 flex items-center justify-between">
        <a
          href="#"
          class="group font-source-code font-extrabold text-xl"
          aria-label="Back to top"
          @click.prevent="scrollToTop"
        >
          <span class="text-turquoise">&lt;</span
          ><span
            class="text-paleBlue transition-colors group-hover:text-waterSpout"
            >jg</span
          ><span class="text-turquoise"> /&gt;</span>
        </a>

        <div class="hidden md:flex items-center space-x-8">
          <a
            v-for="link in links"
            :key="link.href"
            :href="link.href"
            class="nav-link font-outfit text-base text-paleBlue transition-colors hover:text-turquoise"
            @click.prevent="scrollToSection(link.href)"
          >
            {{ link.label }}
          </a>
        </div>

        <button
          v-if="!showMenu"
          type="button"
          aria-label="Open menu"
          class="p-2 md:hidden cursor-pointer"
          @click="showMenu = !showMenu"
        >
          <svg
            class="fill-paleBlue hover:fill-aquamarine"
            width="18"
            height="14"
            viewBox="0 0 18 14"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 1.375C0 0.752734 0.574554 0.25 1.28571 0.25H16.7143C17.4254 0.25 18 0.752734 18 1.375C18 1.99727 17.4254 2.5 16.7143 2.5H1.28571C0.574554 2.5 0 1.99727 0 1.375ZM0 7C0 6.37773 0.574554 5.875 1.28571 5.875H16.7143C17.4254 5.875 18 6.37773 18 7C18 7.62227 17.4254 8.125 16.7143 8.125H1.28571C0.574554 8.125 0 7.62227 0 7ZM18 12.625C18 13.2473 17.4254 13.75 16.7143 13.75H1.28571C0.574554 13.75 0 13.2473 0 12.625C0 12.0027 0.574554 11.5 1.28571 11.5H16.7143C17.4254 11.5 18 12.0027 18 12.625Z"
            />
          </svg>
        </button>
      </div>

      <JHamburgerMenu :show-menu="showMenu" @close="showMenu = false" />
    </nav>
  </header>
</template>

<script setup>
import JHamburgerMenu from "@/components/JHamburgerMenu.vue";
import { ref, onMounted, onUnmounted } from "vue";
import { scrollToSection, scrollToTop } from "@/utils/smoothScroll";

const showMenu = ref(false);
const scrolled = ref(false);
const header = ref(null);

const links = [
  { href: "#about", label: "About me" },
  { href: "#experience", label: "Experience" },
  { href: "#contact", label: "Get in touch" },
];

function handleScroll() {
  scrolled.value = window.scrollY > 24;
}

function handleClickOutside(event) {
  if (showMenu.value && header.value) {
    const headerRect = header.value.getBoundingClientRect();
    const clickX = event.clientX;
    const clickY = event.clientY;

    if (
      clickX < headerRect.left ||
      clickX > headerRect.right ||
      clickY < headerRect.top ||
      clickY > headerRect.bottom
    ) {
      showMenu.value = false;
    }
  }
}

onMounted(() => {
  document.body.addEventListener("click", handleClickOutside);
  window.addEventListener("scroll", handleScroll, { passive: true });
  handleScroll();
});

onUnmounted(() => {
  document.body.removeEventListener("click", handleClickOutside);
  window.removeEventListener("scroll", handleScroll);
});
</script>
